import type { AiCoach_ConfigurationInput as CoachConfigType } from '__generated__/graphql-types';

import { AUTOCOMPLETE_SECTION_PREFIXES } from 'bundles/search-common/constants/autocomplete';

export const ZERO_STATE_AUTOCOMPLETE_AI_PROMPTS_DISPLAY_LIMIT = 6;

export const DEFAULT_QUERY_PROMPTS_FETCH_LIMIT = 10;

export const ASK_ANYTHING_AI_PROMPT_ID = `${AUTOCOMPLETE_SECTION_PREFIXES.AI_PROMPTS_ZERO_STATE}ask-anything`;
export const ASK_ANYTHING_ROUTE_TYPE = 'coach_ask_anything';

export const MAX_AI_PROMPTS_AS_YOU_TYPE = 4;
export const MAX_AS_YOU_TYPE_WITH_AI_PROMPTS_COUNT = 8;

export const DEFAULT_COACH_CONFIG = {
  coachModeId: 'AI_SEARCH',
  coachActionId: 'ROUTER',
};

export const INTENT_TYPES = {
  COST: 'cost',
  SUPPORT: 'support',
  FIND_COURSE_DEGREE: 'find_course_degree',
  EXPLORE_CAREER_SKILL: 'explore_career_skill',
  UNDERSTAND_PRODUCT_TYPE: 'understand_product_type',
  UNDERSTAND_COURSERA: 'understand_coursera',
  LEARNING_PATH: 'learning_path',
};

export const INTENT_TYPE_TO_COACH_CONFIG: Record<string, CoachConfigType> = {
  [INTENT_TYPES.COST]: {
    coachModeId: 'AI_SEARCH_HELP_AND_SUPPORT',
    coachActionId: 'TYPED_MESSAGE',
  },
  [INTENT_TYPES.SUPPORT]: {
    coachModeId: 'AI_SEARCH_HELP_AND_SUPPORT',
    coachActionId: 'TYPED_MESSAGE',
  },
  [INTENT_TYPES.FIND_COURSE_DEGREE]: {
    coachModeId: 'DISCOVERY_FIND_CONTENT',
    coachActionId: 'CONTENT_RETRIEVAL',
  },
  [INTENT_TYPES.EXPLORE_CAREER_SKILL]: {
    coachModeId: 'DISCOVERY_EXPLORE_CAREER_SKILL',
    coachActionId: 'TYPED_MESSAGE',
  },
  [INTENT_TYPES.UNDERSTAND_PRODUCT_TYPE]: {
    coachModeId: 'AI_SEARCH_HELP_AND_SUPPORT',
    coachActionId: 'TYPED_MESSAGE',
  },
  [INTENT_TYPES.UNDERSTAND_COURSERA]: {
    coachModeId: 'AI_SEARCH_HELP_AND_SUPPORT',
    coachActionId: 'TYPED_MESSAGE',
  },
  [INTENT_TYPES.LEARNING_PATH]: {
    coachModeId: 'DISCOVERY_FIND_CONTENT',
    coachActionId: 'CONTENT_RETRIEVAL',
  },
};
